import React from "react";
import { Checkbox } from "./checkbox";
import {
  errorMessageIconStyle,
  errorMessageStyle,
  inputBaseValidationStyle,
} from "./input-base.css";
import {
  wrapperStyle,
  dropdownStyle,
  segmentTitleStyle,
  segmentStyle,
  dropdownContentStyle,
} from "./multi-select.css";
import { Overlay } from "./overlay";
import { selectStyle } from "./select.css";
import { Text } from "@vagastec/ensemble-core";
import { normalizeString } from "../normalizeString";

export function MultiSelect({
  data = null,
  error = false,
  state = [],
  onChange = () => {},
  isSegmented = false,
  segments = [],
  getSegmentIdFromData = () => {},
  renderCustomItem = null,
  renderCustomInputItem = null,
  itemIdKey = "id",
  itemLabelKey = "label",
  shouldValidate = false,
  errorMessage = "",
  validate = (isValidInternally) => isValidInternally,
  onFocus = () => {},
  onBlur = () => {},
  onClick = () => {},
  query = "",
  setQuery = () => {},
  required,
  ...rest
}) {
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const [isAfterBlur, setIsAfterBlur] = React.useState(false);
  const [isFocused, setIsFocused] = React.useState(false);

  function renderData() {
    if (error) return <div>Ocorreu um erro</div>;
    if (!data) return <div>Carregando...</div>;

    if (isSegmented)
      return (
        <>
          {segments.map((segment) => (
            <div key={segment.id} className={segmentStyle}>
              <h3 className={segmentTitleStyle}>{segment.label}</h3>
              {(query
                ? data.filter((v) =>
                    normalizeString(v[itemLabelKey]).includes(
                      normalizeString(query)
                    )
                  )
                : data
              )
                .filter((v) => getSegmentIdFromData(v) === segment.id)
                .map(
                  (v) =>
                    renderCustomItem?.(v) ?? (
                      <Checkbox
                        key={v[itemIdKey]}
                        label={v[itemLabelKey]}
                        value={v[itemIdKey]}
                        checked={state
                          .map((item) => item[itemIdKey])
                          .includes(v[itemIdKey])}
                        onChange={(e) => onChange(v, e.target.checked)}
                      />
                    )
                )}
            </div>
          ))}
        </>
      );
    // .filter(v => v[itemLabelKey].includes())
    return (
      query
        ? data.filter((v) =>
            normalizeString(v[itemLabelKey]).includes(normalizeString(query))
          )
        : data
    ).map(
      (v) =>
        renderCustomItem?.(v) ?? (
          <Checkbox
            key={v[itemIdKey]}
            label={v[itemLabelKey]}
            value={v[itemIdKey]}
            checked={state
              .map((item) => item[itemIdKey])
              .includes(v[itemIdKey])}
            onChange={(e) => onChange(v, e.target.checked)}
          />
        )
    );
  }

  return (
    <div className={wrapperStyle}>
      <input
        {...rest}
        type="text"
        required={required}
        className={`${selectStyle} ${
          inputBaseValidationStyle[
            !validate(!required || state.length) &&
            (isAfterBlur || shouldValidate)
              ? "invalid"
              : "valid"
          ]
        }`}
        value={
          isFocused
            ? query
            : Array.isArray(data)
            ? data
                .map((v) =>
                  state.map((item) => item[itemIdKey]).includes(v[itemIdKey])
                    ? renderCustomInputItem?.(v) ?? `${v[itemLabelKey]}, `
                    : null
                )
                .join("")
                .trim()
                .slice(0, -1) ?? ""
            : ""
        }
        onClick={(e) => {
          onClick(e);
          setIsDropdownOpen(true);
        }}
        onFocus={(e) => {
          setIsFocused(true);
          setIsAfterBlur(false);
          onFocus(e);
        }}
        onBlur={(e) => {
          setIsFocused(false);
          setIsAfterBlur(true);
          onBlur(e);
        }}
        onChange={(e) => setQuery(e.target.value)} // não remover!
      />
      {isDropdownOpen ? (
        <>
          <Overlay
            onClick={(e) => {
              e.preventDefault(); // não remover!
              setIsDropdownOpen(false);
            }}
          />
          <div className={dropdownStyle}>
            <div className={dropdownContentStyle}>{renderData()}</div>
          </div>
        </>
      ) : null}

      {!validate(!required || state.length) &&
      (isAfterBlur || shouldValidate) ? (
        <div className={errorMessageStyle}>
          <svg
            width={16}
            height={16}
            viewBox="0 0 24 24"
            fill="currentColor"
            className={errorMessageIconStyle}
          >
            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.207 12.793l-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z" />
          </svg>
          <Text size="sm" weight={600} as="p">
            {errorMessage}
          </Text>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
